<div class="prescription-checks-container">
  @for (check of prescriptionMedicineStruct.listPrescriptionMedicineCheck; track check) {
    <button
      mat-flat-button color="accent"
      (click)="onClickInPrescriptionCheck(check)"
      class="btn-block prescription-check-button">
      <span>
        {{ check.prescriptionMedicineCheck.idStatusScheduling === statusSchedulingEnum.Suspenso ? '🔴' : check.prescriptionMedicineCheck.idStatusScheduling === statusSchedulingEnum.Concluido ? '🟢' : '' }}
      </span>
      Data e hora aprazadada: <b>{{ check.prescriptionMedicineCheck.datetimeCheckEstimative | date: 'dd/MM/yyyy' }}, {{ check.prescriptionMedicineCheck.datetimeCheckEstimative | date: 'HH:mm' }}</b>
    </button>
  }
</div>
